import React, { useEffect } from 'react'
import OuterHeader from '../components/OuterHeader'
import Footer from '../components/Footer'
import { Link } from 'react-router-dom'

const CancelChallenge = () => {

    useEffect(() => {
        const disableBackButton = (e) => {
            e.preventDefault();
            window.history.forward(); // Forward the user when they try to go back
        };

        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', disableBackButton); // Listen for back button press

        return () => {
            window.removeEventListener('popstate', disableBackButton); // Cleanup the event listener when the component unmounts
        };
    }, []);
    return (
        <>
            <main className="helprr-main">
                <OuterHeader />
                <section className="bg-orange h-100 d-flex align-items-center set-pad">
                    <div className="container">
                        <p className="font_34 font_500 mb-3  text-white text-center">
                            Are you sure you want to cancel today’s challenge?
                        </p>
                        <div className="row justify-content-center">
                            <div className="col-lg-3 col-6">
                                <Link to="/cancel-dashboard" className="dash-btn">
                                    Accept
                                </Link>
                            </div>
                            <div className="col-lg-3 col-6">
                                <Link to="/today-task" className="dash-btn ">
                                    Cancel
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </main>

        </>
    )
}

export default CancelChallenge